exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step[data-v-686b6bf7]{width:70px;height:70px;line-height:70px;display:inline-block;border-radius:100px;z-index:2;left:0;text-align:center;font-size:25px;color:#fff;margin:0 10px;margin-bottom:30px}.step-primary[data-v-686b6bf7]{color:#3c8dbc;background-color:#fff;border-style:solid;border-color:#3c8dbc;line-height:65px}.step-danger[data-v-686b6bf7]{color:#d73925;background-color:#fff;border-style:solid;border-color:#d73925;line-height:65px}.step-warning[data-v-686b6bf7]{color:#f39c12;background-color:#fff;border-style:solid;border-color:#f39c12;line-height:65px}.step-success[data-v-686b6bf7]{color:#00a65a;background-color:#fff;border-style:solid;border-color:#00a65a;line-height:65px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-686b6bf7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/shifts/Shifts.vue
// module id = 428
// module chunks = 0